// @flow
import openpgp from "openpgp";
export default openpgp;

export { key, message, config, enums } from "openpgp";
